// extracted by mini-css-extract-plugin
module.exports = {"pinModalContainer":"_2EmJZ3tIpt-hmydyus-qeV","forgotpin":"Xt0-r0OWn7Yr1poU61AtW"};